import React, { useMemo } from 'react';
import { createFromIconfontCN } from '@fishx/icons';
import * as FishxIcons from '@fishx/icons';

interface IconFontProps {
  type: string,
  url: string,
}

function IconFont(props: IconFontProps) {
  const { type, url, ...rest } = props;

  const Icon = useMemo(
    () =>
      createFromIconfontCN({
        scriptUrl: url,
      }),
    [url]
  );

  const Component = ({ type }) => {
    if (type) {
      const FishIcon = FishxIcons[type];
      return <FishIcon {...rest} />
    } else return null
  }
  if (url) {
    return (<Icon type={type} {...rest} />)
  } else {
    return (
      <Component type={type} {...rest} />
    );
  }
}

export default IconFont;




// WEBPACK FOOTER //
// ./src/components/icon-font/IconFont.tsx